<div [ngClass]="computedClasses">
  <img
    [lazyLoad]="srcPath"
    (load)="onImageLoad()"
    loading="lazy"
    [ngClass]="{ transparent: transparent, loading: !isImageLoaded() }"
    [attr.alt]="(isImageError() || isImageLoaded()) && alt ? name : null"
    (error)="onImageError()" />
</div>

@if (!isImageLoaded()) {
  <cgw-loading-icon class="loading-spinner"></cgw-loading-icon>
}
